import { render, staticRenderFns } from "./ShowRentalClothesCustomers.vue?vue&type=template&id=5e95c6b6&"
import script from "./ShowRentalClothesCustomers.vue?vue&type=script&lang=js&"
export * from "./ShowRentalClothesCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports